import BaseNavigator from './base-navigator';
import _ from 'lodash';
import { onboardingCompleted } from '../store/ducks/user';

export const pages = {
  INTRO_WOLF: 'intro-wolf',
  ACTIVATE_EMAIL: 'activate-email',
  ACTIVATION_STEPS: 'activation-steps',
  CHECKOUT: 'checkout',
  CREATE_ACCOUNT_LOGIN_INFO: 'create-account-login-info',
  LOGIN_WITH_EMAIL: 'login-email',
  PERSONALIZE_START: 'personalize-start',
  FORGOT_PASSWORD: 'forgot-password',
  PLAN_SELECTION: 'plan-selection',
  SHIPPING_ADDRESS: 'shipping-address',
  OPTIONAL_SHIPPING_ADDRESS: 'optional-shipping',
  PERSONALIZE_SUMMARY: 'personalize-summary',
  GENDER: 'gender',
  CURRENT_HEIGHT: 'current-height',
  CURRENT_WEIGHT: 'current-weight',
  WORKOUT_TYPE: 'workout-type',
  MULTI_FITNESS_GOAL: 'multi-fitness-goal',
  MUSCLE_GROUPS: 'muscle-groups',
  PERFORMANCE_AREAS: 'performance-areas',
  GOAL_WEIGHT: 'goal-weight',
  WEEKLY_WEIGHT_LOSS_GOAL: 'weekly-weight-loss-goal',
  PREFERRED_WORKOUT_DAYS: 'preferred-workout-days',
  DAILY_ACTIVITY: 'daily-activity',
  PREFERRED_WORKOUT_LENGTH: 'preferred-workout-length',
  EQUIPMENT_PREFERENCES: 'equipment-preferences',
  USER_PROFILE_LANDING: 'wolf-user-profile'
};

function routeFromMultiFitnessGoals(index, state) {
  const preferences = _.get(state, 'user.multiple_fitness_goals', []);
  if (index < 2 && preferences.indexOf('leanandtone') > -1) {
    return pages.MUSCLE_GROUPS;
  } else if (index < 3 && preferences.indexOf('strengthandpower') > -1) {
    return pages.PERFORMANCE_AREAS;
  } else if (preferences.indexOf('weightloss') > -1) {
    return pages.GOAL_WEIGHT;
  } else {
    return pages.PREFERRED_WORKOUT_DAYS;
  }
}


export default class WolfNavigator extends BaseNavigator {
  static getPages() {
    return pages;
  }

  static getPageList() {
    return Object.keys(pages).map(page => pages[page]);
  }

  constructor(initPage = pages.LOGIN_WITH_EMAIL) {
    super();

    this.initStateMachine(initPage, [
      { name: 'next', from: pages.LOGIN_WITH_EMAIL, to: pages.LOGIN_WITH_EMAIL },
      { name: 'next', from: pages.CREATE_ACCOUNT_LOGIN_INFO, to: pages.CREATE_ACCOUNT_LOGIN_INFO },
      { name: 'next', from: pages.USER_PROFILE_LANDING, to: pages.GENDER },
      { name: 'next', from: pages.GENDER, to: pages.CURRENT_HEIGHT },
      { name: 'next', from: pages.CURRENT_HEIGHT, to: pages.CURRENT_WEIGHT },
      { name: 'next', from: pages.CURRENT_WEIGHT, to: pages.OPTIONAL_SHIPPING_ADDRESS },
      { name: 'next', from: pages.OPTIONAL_SHIPPING_ADDRESS, to: this.onboardingDone },
    ], 'wolf');
  }

  jumpTo(pageName) {
    const realPage = {
      'login': pages.LOGIN_WITH_EMAIL,
      'forgot-password': pages.FORGOT_PASSWORD,
      'join': pages.CREATE_ACCOUNT_LOGIN_INFO,
      'shipping-address': pages.SHIPPING_ADDRESS,
      'optional-shipping': pages.OPTIONAL_SHIPPING_ADDRESS,
      'gender': pages.GENDER,
      'current-height': pages.CURRENT_HEIGHT,
      'current-weight': pages.CURRENT_WEIGHT,
      'workout-type': pages.WORKOUT_TYPE,
      'multi-fitness-goal': pages.MULTI_FITNESS_GOAL,
      'preferred-workout-days': pages.PREFERRED_WORKOUT_DAYS,
      'daily-activity': pages.DAILY_ACTIVITY,
      'preferred-workout-length': pages.PREFERRED_WORKOUT_LENGTH,
      'equipment-preferences': pages.EQUIPMENT_PREFERENCES,
      'create-account-login-info': pages.CREATE_ACCOUNT_LOGIN_INFO
    }[pageName];

    if (!realPage) throw new Error(`Invalid Navigator JumpTo destination: ${pageName}`);

    return super.jumpTo(realPage);
  }

  onboardingDone(state, dispatch) {
    dispatch(onboardingCompleted());
    return pages.OPTIONAL_SHIPPING_ADDRESS;
  }

  fromMultiFitnessGoals(state) {
    return routeFromMultiFitnessGoals(1, state);
  }

  fromMuscleGroups(state) {
    return routeFromMultiFitnessGoals(2, state);
  }

  fromPerformanceAreas(state) {
    return routeFromMultiFitnessGoals(3, state);
  }
}
